const Privacy = () => (
  <svg
    width="28"
    height="28"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.4999 14L12.5449 15.636C13.0324 16.026 13.7406 15.9631 14.1517 15.4932L17.4999 11.6667M6.27382 5.76716L12.1046 3.1757C13.3113 2.63941 14.6886 2.63941 15.8952 3.1757L21.7029 5.75688C23.4012 6.51169 24.516 8.20816 24.397 10.0628C23.9406 17.1769 21.9067 20.3929 16.4087 24.1239C14.9577 25.1086 13.0437 25.1062 11.5917 24.1231C6.11056 20.4123 4.00117 17.2412 3.5816 10.0379C3.47428 8.19539 4.58727 6.51674 6.27382 5.76716Z"
      stroke="#111315"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default Privacy;
